import React from 'react';
import styled from 'styled-components';
import hippa from '../../styles/images/HIPPA.png';

const Icon = styled.div`
  width: 400px;
  height: 400px;
  margin: auto;
  background-size: contain;
  background-image: url(${hippa});
  background-repeat: no-repeat;

  @media screen and (max-width: 768px){
    width: 300px;
    height: 300px;
  }
`;

const HIPPA = () => (
  <Icon />
);

export default HIPPA;



// WEBPACK FOOTER //
// ./src/components/landing/HIPPA.js